/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sortable-col-name[_ngcontent-%COMP%]{cursor:pointer}.sortable-col-name[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{display:none}.sortable-col-name.active[_ngcontent-%COMP%]{color:#007bff}.sortable-col-name.active[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{display:inline-block;margin-left:10px}.sortable-col-name.active.reverse[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{transform:rotate(180deg)}"];
export { styles as styles };
